import React from 'react';
// styles
import styled from 'styled-components';

const PalletizedModalIcon = ({ className, ...props }) => (
  <svg
    role="img"
    aria-label="Palletized info"
    {...props}
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="30" cy="30" r="30" fill="#F2F5F8" />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.8 14H26.9573L20.4573 18.4367H15V37.8H25.6826V36H16.8V20.2367H21.3427L27.8427 15.8H31V24.5551H32.8V14ZM23.8 30H18V34.8H23.8V30ZM19.8 33V31.8H22V33H19.8Z"
      fill="#94A6B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.8 23H44.8V42.8H25V23H31H38.8ZM37 24.8H32.8V26H37V24.8ZM31 24.8V27.8H38.8V24.8H43V41H26.8V24.8H31ZM36 35H41.8V39.8H36V35ZM37.8 36.8V38H40V36.8H37.8Z"
      fill="#94A6B8"
    />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.6291 9.0384C39.7085 6.48423 35.0263 5 30 5C16.1929 5 5 16.1929 5 30C5 35.0263 6.48423 39.7085 9.0384 43.6291L10.3415 42.326C8.09766 38.7552 6.8 34.5304 6.8 30C6.8 17.187 17.187 6.8 30 6.8C34.5304 6.8 38.7552 8.09766 42.326 10.3415L43.6291 9.0384Z"
      fill="#94A6B8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.401 50.8915C20.3216 53.4457 25.0037 54.9299 30.03 54.9299C43.8371 54.9299 55.03 43.7371 55.03 29.9299C55.03 24.9036 53.5458 20.2215 50.9916 16.3009L49.6886 17.6039C51.9324 21.1747 53.23 25.3996 53.23 29.9299C53.23 42.7429 42.843 53.1299 30.03 53.1299C25.4997 53.1299 21.2748 51.8323 17.704 49.5884L16.401 50.8915Z"
      fill="#94A6B8"
    />
  </svg>
);

export default styled(PalletizedModalIcon)``;
